/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { fileModelSchema } from "./fileModelSchema.ts";
import { z } from "zod";

export const chatMessageSenderModelSchema = z.object({
    "id": z.string().uuid().describe("Идентификатор"),
"name": z.string().describe("Имя"),
"avatar": z.lazy(() => fileModelSchema).describe("Аватар").nullable().nullish()
    })